import React from 'react';
import Wishlist from '../../components/home/wishlistComponent/Wishlist';
import EmptyWishlist from '../../components/home/wishlistComponent/EmptyWishlist';
import { useSelector } from "react-redux";

export default function WishlistPage() {
  const wishlistItems = useSelector((state) => state.wishlist.items || []);

  return (
    <div className="w-full">
      {wishlistItems.length > 0 ? (
        <Wishlist />
      ) : (
        <div className="max-w-5xl mx-auto my-8 px-4">
          <EmptyWishlist />
        </div>
      )}
    </div>
  );
}
